import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row, Spinner } from "reactstrap";
import MainNavigation from "../components/MainNavigation";
import { useDispatch, useSelector } from "react-redux";
import ReactStars from "react-rating-stars-component";
import { toast } from "react-toastify";
import { createTheme, ThemeProvider } from "@mui/material";
import TextField from "@mui/material/TextField";
import { withStyles } from "@mui/styles";
import { addPlateformFeedBack } from "../store/actions/restaurantsAction";

const FeedBack = () => {
  const { darkMode, color } = useSelector((state) => state.global);

  const mood = [
    { img: "😕", name: "unhappy" },
    { img: "😐", name: "neutral" },
    { img: "🙂", name: "happy" },
  ];

  const [selectedMood, setSelectedMood] = useState("unhappy");
  const [serviceExperience, setServiceExperience] = useState("unhappy");
  const { feedbackLoader } = useSelector((state) => state.restaurants);
  const { uid } = useSelector((state) => state.authUser);
  const dispatch = useDispatch();
  const { singleUser } = useSelector((state) => state.user);
  const { restaurantsDetail } = useSelector((state) => state.restaurants);
  const [rating, setRating] = useState(1);
  const [feedbackData, setFeedBack] = useState({
    comment: "",
    userID: "",
    restaurantID: "",
  });

  const handleChangeData = (e) => {
    setFeedBack((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const theme = createTheme({
    palette: {
      secondary: {
        main: `${color ? color : "#000000"}`,
      },
    },
  });

  const inputColor = darkMode ? "#ffffff" : "rgb(101 92 92)";

  const ratingChanged = (newRating) => {
    setRating(newRating);
  };

  const CustomTextField = withStyles({
    root: {
      "& fieldset": {
        borderColor: darkMode ? "#95989a" : "rgba(0, 0, 0, 0.125)",
      },
    },
  })(TextField);

  const handleMoodClick = (name) => {
    setSelectedMood(name);
    setServiceExperience(name);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!feedbackData.comment || !serviceExperience || !rating) {
      toast.error("Please fill in all required fields before proceeding");
      return;
    }
    let obj = {
      ...feedbackData,
      rating: rating || 0,
      serviceExperience: serviceExperience || "",
    };
    if (obj.userID) {
      dispatch(addPlateformFeedBack(obj));
      setFeedBack({
        comment: "",
      });
      setSelectedMood("unhappy");
      setServiceExperience("unhappy");
      setRating(1);
    } else {
      toast.error("Please login to give feedback");
    }
  };

  useEffect(() => {
    setFeedBack({
      userID: singleUser?.id,
      restaurantID: restaurantsDetail?.id,
    });
  }, [restaurantsDetail?.id, singleUser]);

  return (
    <>
      <Container>
        {uid ? (
          <>
            <MainNavigation title={"FeedBack"} />
            <Row className="py-5">
              <Col>
                <Row className="mt-4">
                  <Col>
                    <div className="text-center">
                      <h4
                        className={
                          darkMode
                            ? "fs--18 fw--400 mb-0  normal-heading-dark"
                            : "fs--18 fw--400 mb-0  normal-heading"
                        }
                      >
                        Service Efficiency
                      </h4>
                    </div>
                    <Row className="justify-content-center my-3">
                      {mood?.map((item, index) => {
                        return (
                          <h1
                            className={`cursor-pointer mx-2 option ${
                              selectedMood === item.name ? "selected" : ""
                            }`}
                            key={index}
                            onClick={() => handleMoodClick(item.name)}
                          >
                            {item.img}
                          </h1>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <div className="text-center">
                      <h4
                        className={
                          darkMode
                            ? "fs--18 fw--400 mb-0  normal-heading-dark"
                            : "fs--18 fw--400 mb-0  normal-heading"
                        }
                      >
                        Overall Experience
                      </h4>
                    </div>

                    <Row className="justify-content-center my-3">
                      <ReactStars
                        key={rating}
                        required
                        count={5}
                        name="rating"
                        value={rating}
                        onChange={ratingChanged}
                        size={30}
                        isHalf={true}
                        emptyIcon={<i className="far fa-star"></i>}
                        halfIcon={<i className="fa fa-star-half-alt"></i>}
                        fullIcon={<i className="fa fa-star"></i>}
                        activeColor={color}
                      />
                    </Row>
                  </Col>
                </Row>

                <Row>
                  <Col className="d-flex mt-5 justify-content-center align-items-center">
                    <Card
                      className={darkMode ? "auth__card-dark" : "auth__card"}
                    >
                      <ThemeProvider theme={theme}>
                        <Form onSubmit={handleSubmit}>
                          <CustomTextField
                            label="Your Comments"
                            fullWidth
                            className="mb-3"
                            placeholder="Add Your Comment..."
                            multiline
                            rows={4}
                            color="secondary"
                            name="comment"
                            defaultValue={feedbackData.comment}
                            onBlur={(e) => {
                              handleChangeData(e);
                            }}
                            InputLabelProps={{
                              shrink: true,
                              style: {
                                fontSize: "16px",
                                color: darkMode ? "#95989a" : "rgb(101 92 92)",
                              },
                            }}
                            InputProps={{
                              style: {
                                color: inputColor,
                                paddingTop: "10px",
                              },
                            }}
                            variant="outlined"
                          />

                          <Button
                            className="py-3 w-100 auth__btn"
                            style={{
                              background: `${color}`,
                            }}
                            type="submit"
                            disabled={feedbackLoader}
                          >
                            {feedbackLoader ? <Spinner size="md" /> : "Send"}
                          </Button>
                        </Form>
                      </ThemeProvider>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <MainNavigation title={"Login to give feedback"} />
            <Row className="py-5 justify-content-end mx-5"></Row>
          </>
        )}
      </Container>
    </>
  );
};

export default FeedBack;
